/**
 * /me/payments/ytd — Session 3d PR 9.
 * Owning agent: Khidmat. Detail-card-style page (NOT a list).
 */

import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { ErrorPanel, Loading } from "../components/Loading";
import { session3dApi } from "../lib/session3d-api";
import {
  MeActionsRow,
  MeEmployeeRequiredGate,
  Session3dMeShell,
  useCurrentEmployeeId,
} from "./_session3dShell";

export function MyYtdStatementPage() {
  const { t } = useTranslation();
  const employeeId = useCurrentEmployeeId();

  const query = useQuery({
    queryKey: ["s3d-ytd-statement", employeeId],
    queryFn: () => session3dApi.getYtdStatement(employeeId),
    enabled: !!employeeId,
  });

  const data = query.data;

  return (
    <MeEmployeeRequiredGate>
      <Session3dMeShell
        title={t("me.ytd-statement.title", "YTD Statement")}
        subtitle={t("me.ytd-statement.subtitle", "Year-to-date earnings + deductions summary.")}
        briefContext={{
          total: 1,
          attention: 0,
          critical: 0,
          top_kind: t("me.ytd-statement.title", "YTD Statement"),
          window_label: t("me.ytd-statement.window", "this year"),
        }}
        actionsRow={
          <MeActionsRow
            khidmatPrefill={t("me.ytd-statement.ask_khidmat", "Show me my year-to-date earnings.")}
          />
        }
      >
        {query.isLoading && <Loading />}
        {query.isError && <ErrorPanel message={(query.error as Error).message} />}
        {data && (
          <div className="rounded-2xl border border-border-subtle bg-white p-4 text-sm">
            <p className="text-xs text-text-tertiary">
              {t(
                "me.ytd-statement.detail_note",
                "Year-to-date earnings + deductions summary for personal records (tax · loans · benefits). Downloadable as PDF for personal banking.",
              )}
            </p>
            <pre className="mt-3 overflow-x-auto rounded bg-surface-sunken p-3 font-mono text-[10px] text-text-secondary">
{JSON.stringify(data, null, 2)}
            </pre>
          </div>
        )}
      </Session3dMeShell>
    </MeEmployeeRequiredGate>
  );
}
